package devxertech.com.pages.industries.sportsIndustry


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.industries.sportsIndustry.sportsFuture.SportsFuture
import devxertech.com.pages.industries.sportsIndustry.sportsManagement.SportsManagement
import devxertech.com.pages.industries.sportsIndustry.sportsServices.SportsServices
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/sports-industry")
@Composable
fun SportsIndustry() {
    PageMetadataForCurrentRoute()
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            mainHeadingAsH1 = true,
            image =   Res.Image.sport_header,
            imageAlt = "Sports technology solutions",
            breakpoint = breakpoint,
            headingText = "Sports Software \n" +
                    "Development",
            descriptionText = "We help sports organisations plan and build digital platforms for their teams, operations and audiences. Discuss your requirements with Devxer to define the right project scope."
        )
        CommonArrow("Sports")
        SportsFuture()
        SportsServices(breakpoint, sitePalette)
        MakeYourOwnTeam(breakpoint)
        SportsManagement()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}
